module.exports = __webpack_public_path__ + "static/media/mic-icon.8a3265eb.svg";